import type {
  StorefrontAvailabilityNotificationCreateResponseType,
  StorefrontAvailabilityNotificationCreateRequestType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSellarCurrentBusiness } from "../../../../useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../useFirebaseUser.shared";
import { apiV2AssertResponse, apiV2Request } from "../../apiV2Request";
import { ServerStateKeys } from "../../ServerStateKeys";

export const useSupplierStorefrontAvailabilityNotificationCreate = (
  supplierId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: StorefrontAvailabilityNotificationCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `suppliers/${supplierId}/storefront/availability/notification`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as StorefrontAvailabilityNotificationCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.StorefrontAvailabilityNotification,
          supplierId,
        ],
      });
    },
  });
};
